import { useWhitelabel } from './useWhitelabel';
import { useEffect, useState } from 'react';

export const useTheme = () => {
  const { whitelabelTheme, isLoadingTheme } = useWhitelabel();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (isLoadingTheme) {
      return;
    }
    const applyTheme = () => {
      const root = document.documentElement;

      Object.entries(whitelabelTheme).forEach(([key, value]) => {
        root.style.setProperty(`--${key}`, value as string);
      });
    };
    applyTheme();

    setIsLoading(false);
  }, [isLoadingTheme, whitelabelTheme]);

  return { isLoading };
};
